import React from 'react'
import Text from 'core/elements/Text'
import Button from 'core/elements/button'
import Modal from 'core/elements/modal'

interface Props {
  onClose: () => void
}

const ThemeEnabledDialog = ({ onClose }: Props) => {
  return (
    <Modal open panel="dialog" onClose={onClose} footer={<Button onClick={onClose}>OK</Button>}>
      <Text variant="body2">Custom theme saved successfully.</Text>
    </Modal>
  )
}

export default ThemeEnabledDialog
